import React from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutGrid, List } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * BUG-platform — Reusable Grid / List view toggle.
 *
 *   const [view, setView] = useState('grid');
 *   ...
 *   <ListGridToggle value={view} onChange={setView} testIdPrefix="evals" />
 *
 * Renders ES/EN labels off `common.viewGrid` / `common.viewList`.
 */
export function ListGridToggle({ value, onChange, testIdPrefix = 'view' }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-1" data-testid={`${testIdPrefix}-toggle`}>
      <Button
        size="sm"
        variant={value === 'grid' ? 'default' : 'outline'}
        onClick={() => onChange('grid')}
        className="gap-1.5"
        data-testid={`${testIdPrefix}-grid`}
        aria-pressed={value === 'grid'}
      >
        <LayoutGrid className="h-4 w-4" /> <span className="hidden sm:inline">{t('common.viewGrid')}</span>
      </Button>
      <Button
        size="sm"
        variant={value === 'list' ? 'default' : 'outline'}
        onClick={() => onChange('list')}
        className="gap-1.5"
        data-testid={`${testIdPrefix}-list`}
        aria-pressed={value === 'list'}
      >
        <List className="h-4 w-4" /> <span className="hidden sm:inline">{t('common.viewList')}</span>
      </Button>
    </div>
  );
}
